export const bytesToGigabytes = (bytes: number | null): number | null => bytes != null ? (bytes / Math.pow(10, 9)) : null;

export const secondsToHours = (seconds: number | null): number | null => seconds != null ? (seconds / 60 / 60) : null;
